import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch, ref } from 'vue'
import { IonToast } from '@ionic/vue'
import { closeCircleOutline } from 'ionicons/icons'

import { useControlStore } from '@/store/control'


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorToast',
  setup(__props) {

const control = useControlStore()

const showToast = ref(false)
const toastDuration = ref(2500)

watch(
  () => control.error,
  () => {
    showToast.value = true
    setTimeout(() => {
      control.$patch({ error: null })
      showToast.value = false
    }, toastDuration.value)
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IonToast), {
      "is-open": showToast.value,
      icon: _unref(closeCircleOutline),
      message: _unref(control).error,
      duration: toastDuration.value,
      position: "top",
      cssClass: "toast-error"
    }, null, 8, ["is-open", "icon", "message", "duration"])
  ]))
}
}

})